/**
 * Created by frank.law on 11/13/17.
 */
const loginState = {
    login: {
        isLoading: false,
        loginAttempts: 0,
        username: undefined,
        errorText: undefined,
        password: undefined,
        newPassword: undefined,
        confirmPassword: undefined,
        newPasswordValidated: undefined,
        challengeResponse: {}
    },
   forms: {}

};

export default loginState;

